import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { snowplowEvent, userToUserContextSchemaData } from 'lib/analytics'
import { useUnFollowUserMutation } from 'store/api/yay/user'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const ConfirmBoxUnfollow = ({ isActive, data, onClose, onOk }) => {
  const { t } = useTranslation()

  const [unFollowerUser] = useUnFollowUserMutation()

  const onUnfollowUser = useCallback(() => {
    const userId = data?.user?.id

    unFollowerUser(userId).then((res: any) => {
      if ((res?.data?.result ?? '') == 'success') {
        snowplowEvent.unfollow({
          user: userToUserContextSchemaData({ user: data.user }),
        })
        onOk()
      }
    })
  }, [data])

  return (
    <ConfirmBoxBasic
      isActive={isActive}
      onClose={onClose}
      onOk={onUnfollowUser}
      title={t('common.unfollow')}
      content={t('confirm_box_unfollow.content')}
      confirmButtonText={t('common.unfollow')}
      onCancel={onClose}
    />
  )
}

export default ConfirmBoxUnfollow
